/**
 * @file useIsMobile.js
 * @location src/hooks/useIsMobile.js
 * @role 모바일(≤768px) 여부 — matchMedia 구독. 표→카드 전환 등 JS 분기에만 사용.
 *   matchMedia 부재(jsdom/SSR) 시 false → 데스크탑(표) 모드로 안전 폴백.
 */
import { useState, useEffect } from 'react';

const QUERY = '(max-width: 768px)';
const supported = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => (supported() ? window.matchMedia(QUERY).matches : false));
  useEffect(() => {
    if (!supported()) return;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
